import {
  GlobalFilterRuleFormData,
} from '../../../integrated-client/models/';

import { RuleFormDataAgencyOrGroup } from '../../../integrated-client/models/';

export interface IGlobalFilterMOCData {
  agenciesAndGroups?: RuleFormDataAgencyOrGroup[] | null;
}

export type GlobalFiltersEditorData = GlobalFilterRuleFormData & IGlobalFilterMOCData

export interface IGlobalFiltersEditorData {
  editorData?: GlobalFiltersEditorData
  validation?: any
  readyToSave: boolean
}

export class EditorData implements IGlobalFiltersEditorData{
  editorData?: GlobalFiltersEditorData
  validation?: any
  readyToSave: boolean

  constructor() {
    this.readyToSave = false;
  }
}
